import { render, staticRenderFns } from "./AttributeValueEditor.vue?vue&type=template&id=fa4a1308&scoped=true&"
import script from "./AttributeValueEditor.vue?vue&type=script&lang=js&"
export * from "./AttributeValueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4a1308",
  null
  
)

export default component.exports